(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/api-proxy/assets/javascripts/path-to-regexp.js') >= 0) return;  svs.modules.push('/components/lb-utils/api-proxy/assets/javascripts/path-to-regexp.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const REGEXP_SPECIAL_CHARS = /[.+*?^${}()|[\]\\]/g;
const PARAM_NAME_CHARS = /[A-Za-z0-9_]/;
const PARAM_MODIFIERS = /[?*+]/;
const escapeLiteral = value => value.replace(REGEXP_SPECIAL_CHARS, '\\$&');
const splitUrl = input => {
  const str = String(input);
  const hashIndex = str.indexOf('#');
  const withoutHash = hashIndex === -1 ? str : str.slice(0, hashIndex);
  const queryIndex = withoutHash.indexOf('?');
  if (queryIndex === -1) {
    return {
      path: withoutHash,
      query: ''
    };
  }
  return {
    path: withoutHash.slice(0, queryIndex),
    query: withoutHash.slice(queryIndex + 1)
  };
};
const safeDecode = value => {
  try {
    return decodeURIComponent(value.replace(/\+/g, ' '));
  } catch (error) {
    return value;
  }
};
const parseQuery = query => {
  const params = {};
  if (!query) {
    return params;
  }
  const pairs = query.split('&');
  for (let i = 0; i < pairs.length; i++) {
    const pair = pairs[i];
    if (!pair) {
      continue;
    }
    const eqIndex = pair.indexOf('=');
    const rawKey = eqIndex === -1 ? pair : pair.slice(0, eqIndex);
    const rawValue = eqIndex === -1 ? '' : pair.slice(eqIndex + 1);
    const key = safeDecode(rawKey);
    const value = safeDecode(rawValue);
    if (Object.prototype.hasOwnProperty.call(params, key)) {
      const existing = params[key];
      if (Array.isArray(existing)) {
        existing.push(value);
      } else {
        params[key] = [existing, value];
      }
    } else {
      params[key] = value;
    }
  }
  return params;
};
const collectKeysFromRegExp = regexp => {
  const keys = [];
  const namedGroupPattern = /\(\?<([A-Za-z0-9_]+)>/g;
  const source = regexp.source;
  let namedMatch = namedGroupPattern.exec(source);
  while (namedMatch !== null) {
    keys.push({
      name: namedMatch[1],
      modifier: ''
    });
    namedMatch = namedGroupPattern.exec(source);
  }
  if (keys.length === 0) {
    const groupPattern = /\((?!\?)/g;
    let groupIndex = 0;
    while (groupPattern.exec(source) !== null) {
      keys.push({
        name: groupIndex,
        modifier: ''
      });
      groupIndex++;
    }
  }
  return keys;
};
const parseRawGroup = (path, startIndex) => {
  let depth = 1;
  let j = startIndex + 1;
  while (j < path.length && depth > 0) {
    const char = path[j];
    if (char === '\\' && j + 1 < path.length) {
      j += 2;
      continue;
    }
    if (char === '(') {
      depth++;
    } else if (char === ')') {
      depth--;
      if (depth === 0) {
        break;
      }
    }
    j++;
  }
  if (depth !== 0) {
    throw new TypeError("Unbalanced parenthesis in path \"".concat(path, "\""));
  }
  return {
    group: path.slice(startIndex, j + 1),
    endIndex: j
  };
};
const parseParameter = (path, startIndex) => {
  let j = startIndex + 1;
  while (j < path.length && PARAM_NAME_CHARS.test(path[j])) {
    j++;
  }
  const name = path.slice(startIndex + 1, j);
  let modifier = '';
  if (name && j < path.length && PARAM_MODIFIERS.test(path[j])) {
    modifier = path[j];
    j++;
    if (modifier === '*' && j < path.length && path[j] === '*') {
      j++;
    }
  }
  return {
    name,
    modifier,
    endIndex: j
  };
};
const buildParameterPattern = modifier => {
  switch (modifier) {
    case '?':
      return '([^/]*?)?';
    case '*':
      return '(.*)';
    case '+':
      return '(.+)';
    default:
      return '([^/]+?)';
  }
};
const pathToRegexpFromString = (path, options) => {
  const {
    sensitive = false,
    strict = false,
    end = true,
    start = true
  } = options;
  const {
    path: pathPattern
  } = splitUrl(path);
  const keys = [];
  let pattern = '';
  let anonymousIndex = 0;
  let i = 0;
  while (i < pathPattern.length) {
    const char = pathPattern[i];
    if (char === '\\' && i + 1 < pathPattern.length) {
      pattern += escapeLiteral(pathPattern[i + 1]);
      i += 2;
      continue;
    }
    if (char === '(') {
      const {
        group,
        endIndex
      } = parseRawGroup(pathPattern, i);
      pattern += group;
      keys.push({
        name: anonymousIndex++,
        modifier: ''
      });
      i = endIndex + 1;
      continue;
    }
    if (char === ':') {
      const {
        name,
        modifier,
        endIndex
      } = parseParameter(pathPattern, i);
      if (!name) {
        pattern += '\\:';
        i++;
        continue;
      }
      pattern += buildParameterPattern(modifier);
      keys.push({
        name,
        modifier
      });
      i = endIndex;
      continue;
    }
    pattern += escapeLiteral(char);
    i++;
  }
  let finalPattern = pattern;
  if (start) {
    finalPattern = "^".concat(finalPattern);
  }
  if (!strict) {
    finalPattern += '/?';
  }
  if (end) {
    finalPattern += '$';
  }
  const flags = sensitive ? '' : 'i';
  return {
    regexp: new RegExp(finalPattern, flags),
    keys
  };
};
const pathToRegexp = function (path) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (path instanceof RegExp) {
    return {
      regexp: path,
      keys: collectKeysFromRegExp(path)
    };
  }
  if (Array.isArray(path)) {
    const keys = [];
    const sources = path.map(entry => {
      const result = pathToRegexp(entry, _objectSpread(_objectSpread({}, options), {}, {
        start: false,
        end: false
      }));
      keys.push(...result.keys);
      return result.regexp.source;
    });
    const {
      sensitive = false,
      start = true,
      end = true,
      strict = false
    } = options;
    let combined = "(?:".concat(sources.join('|'), ")");
    if (start) {
      combined = "^".concat(combined);
    }
    if (!strict) {
      combined += '/?';
    }
    if (end) {
      combined += '$';
    }
    const flags = sensitive ? '' : 'i';
    return {
      regexp: new RegExp(combined, flags),
      keys
    };
  }
  return pathToRegexpFromString(path, options);
};
const match = (path, options) => {
  const {
    regexp,
    keys
  } = pathToRegexp(path, options);
  return function matcher(input) {
    const {
      path: pathOnly,
      query
    } = splitUrl(input);
    const matches = regexp.exec(pathOnly);
    if (!matches) {
      return false;
    }
    const matchedPath = matches[0];
    const params = {};
    const queryParams = parseQuery(query);
    const queryKeys = Object.keys(queryParams);
    for (let i = 0; i < queryKeys.length; i++) {
      params[queryKeys[i]] = queryParams[queryKeys[i]];
    }
    for (let i = 1; i < matches.length; i++) {
      if (matches[i] === undefined) {
        continue;
      }
      const key = keys[i - 1];
      if (!key) {
        continue;
      }
      params[key.name] = decodeURIComponent(matches[i]);
    }
    return {
      path: matchedPath,
      params
    };
  };
};
const pathToRegexpExports = {
  match,
  pathToRegexp
};
if (svs.isServer) {
  module.exports = pathToRegexpExports;
} else {
  setGlobal('svs.components.lbUtils.apiProxy.pathToRegexp', pathToRegexpExports);
}

 })(window);